module.exports = __webpack_public_path__ + "img/c05_unitpontifex_Normal_ua.9dbaa640.webp";